import { useEffect } from "react";
import LanguageService from "../service/languageService";
import { useAppSelector } from "../store/hooks";
import HomePage from "./HomePage";
import LoginPage from "./LoginPage";
import i18n from "../service/translations/translationService";

export default function MainPage() {
  const { isLogin } = useAppSelector((state) => state.authenticationSlice);
  const params = new URLSearchParams(window.location.search);
  const language =
    params.get("language") ?? LanguageService.fetchSystemLanguage();

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  return (
    <div>
      {isLogin && <HomePage />}
      {isLogin === false && <LoginPage />}
    </div>
  );
}
